export default "__VITE_ASSET__D6bwDZ_v__"